import Excel from "exceljs";
import _ from "lodash";
import moment from "moment";

export default function extractManningsMonthlyData(
  file,
  productData,
  locationData,
  selectedDate
) {
  return new Promise(async (resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    const startDate = moment(selectedDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    const endDate = moment(selectedDate).endOf("month").format("YYYY-MM-DD");

    let salesDatas = [];
    let days = new Set();
    let arrayOfDay = [];
    //1 unique id = mannings code + date value
    //2 mannings code
    //3 product desc
    //4 date value
    //5 qty
    //6 category
    //7 unit price
    //8 selling price
    //9 total amount
    //10 Promotion
    //11 M18
    //13 Brnad
    let isNewFormat = false;
    let dataInRowIndex = 5;
    reader.onload = () => {
      const buffer = reader.result;
      try {
        wb.xlsx.load(buffer).then(async (workbook) => {
          const salesDataWorkSheet = workbook.getWorksheet(1);
          salesDataWorkSheet.eachRow((row, rowIndex) => {
            if (rowIndex <= 3) {
              row.eachCell((cell) => {
                const day = moment(cell.value);
                if (day.isValid() && cell.numFmt === "mm-dd-yy") {
                  if (rowIndex === 1) {
                    isNewFormat = true;
                    dataInRowIndex = 3;
                  }
                  // if (!day.isBetween(startDate, endDate, "day", "[]")) {
                  //   reject({ message: "dateIsNotCorrect" });
                  //   return false;
                  // }
                  days.add(day.format("YYYY-MM-DD"));
                }
              });
              arrayOfDay = Array.from(days);
            }

            if (rowIndex >= dataInRowIndex && row.values[4]) {
              let colCount = isNewFormat ? 6 : 7;
              _.forEach(arrayOfDay, (day) => {
                const salesData = {};
                if (typeof row.values[colCount] === "number") {
                  let shopCode = row.values[4];
                  if (typeof shopCode === "number") {
                    shopCode = `M5${shopCode}`;
                    // console.log("shopCode", shopCode);
                  }
                  if (locationData[shopCode]) {
                    if (!productData[_.padStart(row.values[1], 6, "0")]) {
                      reject({
                        message: "productNotExist",
                        id: _.padStart(row.values[1], 6, "0"),
                      });
                      return false;
                    }
                    salesData.shopCode = shopCode;
                    salesData.location_id = locationData[shopCode];
                    salesData.product_id =
                      productData[_.padStart(row.values[1], 6, "0")].product_id;
                    salesData.tx_date = day;
                    salesData.qty = row.values[colCount];
                    salesData.amount = row.values[colCount + 1];
                    salesDatas.push(salesData);
                  }
                }
                colCount += 2;
              });
            }
          });
          resolve(salesDatas);
        });
      } catch (err) {
        console.log(err);

        throw err;
      }
    };
  });
}
